/*eslint-disable multiline-ternary */
import React, { useState } from 'react';
import { Col, Container, Row, InputGroup } from 'react-bootstrap';
import useViewAllDocuments from './hooks/useViewAllDocuments';
import { Link } from 'react-router-dom';
import TextInput from 'src/Components/GenericInputText/TextInput';
import { BackAvatarSVG, SearchSVG } from '../../img/GlobalSVG';
import { SendDocumentIconSVG } from '../../img/uploadDocument/uploadDocumentSVG';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import DocumentListTable from './DocumentTable/DocumentListTable';
import CustomPaginationItemsDisplay from '../common/pagination/CustomPaginationItemsDisplay';
import CustomPagination from '../common/pagination';
import './UploadDocument.scss';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import ViewDocumentListSkeleton from './skeleton/ViewDocumentListSkeleton';
import MasterPermissions from '../../api/MasterPermissions';

const ViewAllDocuments = () => {
  const [accessibilityCurrentPage, setAccessibilityCurrentPage] = useState(0);
  const {
    pageInfo,
    isNotFound,
    filteredRecords,
    pageSize,
    currentPage,
    totalRecords,
    searchText,
    columnNames,
    displayPaginationMininumCount,
    loadingApiConfig,
    isAPIFailed,
    pageSizeHandler,
    paginationHandler,
    onSearch,
    customSortingHandler,
    recordsFilterHandler,
  } = useViewAllDocuments();

  return (
    <>
      <div>
        <div className="documents-filter-container filter-bar-border-top filter-bar-border-bottom mt-4 mb-md-4 mb-xs-3">
          <Container>
            <Row className="justify-content-between">
              <Col
                xs={12}
                sm={6}
                md={8}
                lg={5}
                className=" border-right-documents py-3"
              >
                <label htmlFor="filterByTitleReference" className="sr-only">
                  Search by title
                </label>
                <TextInput
                  parentClassName="document-search"
                  append={
                    <InputGroup.Text>
                      <SearchSVG.SearchSVG className="primary-text-color" />
                    </InputGroup.Text>
                  }
                  inputProps={{
                    type: 'text',
                    placeholder: 'Search by Title',
                    className: 'border-right-0 height-32',
                    value: searchText,
                    onChange: onSearch,
                    id: 'filterByTitleReference',
                  }}
                />
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                lg={5}
                className="send-document-button py-3"
              >
                {MasterPermissions.CheckPermission('Upload Document') ? (
                  <Link to="/member/upload-document">
                    <GenericButton
                      variant="primary"
                      tabIndex={0}
                      ariaLabel="Click to go to send document screen"
                    >
                      <span className="mr-2">
                        <SendDocumentIconSVG />
                      </span>
                      Send Documents
                    </GenericButton>
                  </Link>
                ) : (
                  <GenericButton
                    disable={true}
                    buttonDisabled={true}
                    tabIndex={0}
                  >
                    <span className="mr-2">
                      <SendDocumentIconSVG />
                    </span>
                    Send Documents
                  </GenericButton>
                )}
              </Col>
            </Row>
          </Container>
        </div>
        <Container>
          {loadingApiConfig ? (
            <ViewDocumentListSkeleton />
          ) : (
            <>
              {isAPIFailed ? (
                <div className="p-0">
                  {isNotFound ? (
                    <div className="document-no-data text-center">
                      <CustomClientError
                        CustomClasses="p-0 m-0"
                        ErrorHeading="No Documents found!"
                        ErrorMessage="We could not find any documents for the selected search.
                try again."
                      />
                    </div>
                  ) : (
                    <CustomClientError
                      ErrorHeading="Something went wrong with request!"
                      ErrorMessage="Please try again."
                    />
                  )}
                </div>
              ) : (
                <>
                  <div className="d-flex justify-content-between mt-4 pagination-container">
                    {totalRecords > displayPaginationMininumCount ? (
                      <CustomPaginationItemsDisplay
                        pageSize={pageSize}
                        setPageSize={pageSizeHandler}
                        prefixMessage="Records per page"
                        suffixMessage={`Showing ${
                          currentPage * pageSize - pageSize + 1
                        } - ${
                          pageSize * currentPage < totalRecords
                            ? pageSize * currentPage
                            : totalRecords
                        } of ${totalRecords} results`}
                      />
                    ) : null}

                    <div className="d-flex align-items-center">
                      {totalRecords > displayPaginationMininumCount ? (
                        <CustomPagination
                          className="p-0 m-0"
                          pageSize={pageSize}
                          currentPage={currentPage}
                          totalCount={totalRecords}
                          onPageChange={paginationHandler}
                          accessibilityPagination={true}
                          accessibilityCurrentPage={accessibilityCurrentPage}
                          setAccessibilityCurrentPage={
                            setAccessibilityCurrentPage
                          }
                        />
                      ) : null}
                    </div>
                  </div>

                  <div className="document-list-table mt-4">
                    <DocumentListTable
                      className="account-table"
                      columns={columnNames}
                      data={filteredRecords}
                      keyField={columnNames}
                      pageSizeCount={pageSize}
                      initialSortBy={{
                        id: 'SentDate',
                        desc: true,
                      }}
                      customSortingHandler={customSortingHandler}
                    />
                  </div>
                  <div className="d-flex justify-content-between mt-4 pagination-container-2">
                    {totalRecords > displayPaginationMininumCount ? (
                      <CustomPaginationItemsDisplay
                        pageSize={pageSize}
                        setPageSize={pageSizeHandler}
                        prefixMessage="Records per page"
                      />
                    ) : null}

                    <div className="d-flex align-items-center">
                      {totalRecords > displayPaginationMininumCount ? (
                        <CustomPagination
                          className="p-0 m-0"
                          pageSize={pageSize}
                          currentPage={currentPage}
                          totalCount={totalRecords}
                          onPageChange={paginationHandler}
                          accessibilityPagination={true}
                          accessibilityCurrentPage={accessibilityCurrentPage}
                          setAccessibilityCurrentPage={
                            setAccessibilityCurrentPage
                          }
                        />
                      ) : null}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default ViewAllDocuments;
